<header class="mast-main-head fixed-top">

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

    <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" (click)="openMarketplace()" style="cursor: pointer;">Marketplace</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" routerLink="/pricing">Pricing</a>
        </li>
        <li class="nav-item dropdown col-1-dropdown">
          <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
          <div class="dropdown-menu" style="width: 200px;">
            <ul>
              <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="Icons/Navigation/Arrow Down/Black">
                    <g id="Group">
                      <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                  </g>
                </svg> -->
              </li>
              <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
              <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
            </ul>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
        </li>
         <li class="nav-item signup-btn">
        <a class="nav-link button" href="profile.html" data-toggle="modal" routerLink="/login">Start for free</a>
        </li>
        <li class="nav-item login-btn">
        </li>
      </ul>
      </div>
    </div>
  </nav>
</header>

<section class="feedback-section-header">
	<div class="container">
		<div class="row">
			<div class="col-sm-12">
				<div class="inner-content">
					<h1>FAQs <img src="assets/img/ques.png" style="height: 80px;"></h1>
          <p>Thank you for visiting our FAQ page. We hope you find the information you need to make your experience with us as smooth as possible. If you have any further questions or require assistance, please do not hesitate to get in touch with our dedicated support team.</p>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="faq-section-top">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>Getting Started</h3>
          <p>Frequently asked questions about our products and services.</p>
          <hr>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="faq-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-5">
        <div class="inner-content">
          <h4>What is a Workspace?</h4>
          <p>Workspace is a platform where you can store and access your digital assets securely and safely. You can access, download, share, move, etc your digital assets anytime you want without any hassle.</p>

        </div>
      </div>
      <div class="col-sm-5 right-question">
        <div class="inner-content">
          <h4>How many assets can I upload?</h4>
          <p>At Crafttor's workspace you can upload any number of digital assets inside boards/categories you will create. There is no limitation in uploading the assets. We will provide you enough space as per plans for uploading unlimited number of assets.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="faq-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-5">
        <div class="inner-content">
          <h4>Is it free to upload assets?</h4>
          <p>Yes, ofcourse we do have a free space to upload and access digital assets but our free plan has a limited space along with other limitations. Based on user's requirements and the space needed for uploading and managing assets we provide different plans.</p>
        </div>
      </div>
      <div class="col-sm-5 right-question">
        <div class="inner-content">
          <h4>What type of digital assests I can upload?</h4>
          <p>A user can upload digital assets which includes images, illustrations, pictures. There are multiple kind of image formats which you can easily upload to your workspace. Currently we support SVG, PNG & JPG formats for uploading/downloading or for accessing.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="faq-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-5">
        <div class="inner-content">
          <h4>What free plan includes?</h4>
          <p>Our free plan is for every user who signin to Crafttor's workspace. A free plan includes 2GB of space for storing and accessing digital assests. In a free plan only the owner can view and access the workspace and its data but an owner can't invite any further user to access their workspace.</p>
        </div>
      </div>
      <div class="col-sm-5 right-question">
        <div class="inner-content">
          <h4>What type of formats one can upload?</h4>
          <p>In each plan we allow users to upload digital assets in three formats i.e SVG, PNG, JPG. Other than these we do not support any other format currently. In case if a user needs to upload assets other than these formats, please email us the same.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="faq-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-5">
        <div class="inner-content">
          <h4>How can I contact sales directly?</h4>
          <p>In case if a user needs extra amount of space in their workspace other than what we provide in our Plus and Professional plans then a user can directly email us or we have an option of Contact Sales on subscritpion page. Fill the form and submit. Crafftor's team will revert asap.</p>

        </div>
      </div>
      <div class="col-sm-5 right-question">
        <div class="inner-content">

          <h4>How can I access my assets on Figma?</h4>
          <p>To access illustrations/assets on Figma, create a free account and choose the starter pack with 30-days version history and unlimited cloud storage. Go to Menu > Plugins > Browse Plugins in Community and search for Crafftor. Install the plugin and now a user can access their assets along with Crafttor's illustrations.</p>
        </div>
      </div>
    </div>
  </div>
  </section>

<section class="faq-section">
    <div class="container">
      <div class="row">
        <div class="col-sm-5">
          <div class="inner-content">
            <h4>Is there any offer or a free trial?</h4>
            <p>Yes, we do have a free plan & we can provide a free trial in case if a user needs. In that case a user needs to contact the sales team to get a free trial on how workspace works and how a user can upload/download and access their assets smoothly and securely.</p>
          </div>
        </div>
        <div class="col-sm-5 right-question">
          <div class="inner-content">
            <h4>Which plan should I choose?</h4>
            <p>We have one free and two paid plans going on. Along side we do provide a custom plan in which a user can select the amount space needed and how many invites a user wants in his/her plan. Free plan has a limited space and no further invites. You can check out <b>https://workspace.crafttor.com/pricing</b> for more details about all the plans.</p>
          </div>
        </div>
      </div>
    </div>
</section>


  <section class="faq-section">
    <div class="container">
      <div class="row">
        <div class="col-sm-5">
          <div class="inner-content">
            <h4>How to use plugins for my assets?</h4>
            <p>Find your desired plugin and then set up as per the plugin document. Once done with the set up a user needs to signin and after signin success a user is good to go using the plugin for crafttor's illustrations along with their own assets uploaded at Crafttor's workspace.</p>

          </div>
        </div>
        <div class="col-sm-5 right-question">
          <div class="inner-content">
            <h4>Is there any assets download limit?</h4>
            <p>No, Please note that when a user creates a workspace then it is their personal space for uploading/downloading or accessing their assets. A user can download any number of images/illustraions uploaded by them in a day/week/month.</p>
          </div>
        </div>
      </div>
    </div>
  </section>


    <section class="faq-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-5">
            <div class="inner-content">
              <h4>How many boards/categories an owner can create?</h4>
              <p>There is no limitation in creating the boards/categories. An owner can create any number of boards/categories. The owner of the workspace can add Admins or members via invitation and they too can create any number boards/categories.</p>
            </div>
          </div>
          <div class="col-sm-5 right-question">
            <div class="inner-content">
              <h4>How to invite a sub user in a workspace?</h4>
              <p>The owner of the workspace can invite sub users to access the workspace by providing the email Id in the people section. The owner has to send invite via emails in people section and we will list down the users to whom the owner has sent invitation.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="faq-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-5">
            <div class="inner-content">
              <h4>How many sub users an owner can add?</h4>
              <p>The owner can send invite to sub users based on the plans. In the free plan there is no further invitation allowed to add sub users. In Plus and Professional plan the owner can send 3 and 5 invites respectively.</p>
            </div>
          </div>
          <div class="col-sm-5 right-question">
            <div class="inner-content">
              <h4>Can only owner has authority to send invites?</h4>
              <p>No, not only the owner but if the owner has added someone with Admin role as sub user then the Admin can also send invites. The Admin has the same rights as that of the Owner to send invites and add sub users to access the workspace.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="faq-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-5">
            <div class="inner-content">
              <h4>Can a single workspace have two owners?</h4>
              <p>No, we stick to one owner of one workspace at a time. The owner can add multiple Admins or Members based on the plan but there couldn't be more than one owner at a time. We allow few features only to the owner and allowing two owners can create a conflict.</p>
            </div>
          </div>
          <div class="col-sm-5 right-question">
            <div class="inner-content">
              <h4>How to leave the workspace?</h4>
              <p>We provided leave workspace option only to Admins or Members in which they are added as sub users. We do not allow owner to leave the workspace because the owner is the creator. For leaving the workspace one can access People section and opening the  manage your account option will show leave this workspace option.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

  <section class="faq-section">
  	<div class="container">
  		<div class="row">
  			<div class="col-sm-5">
  				<div class="inner-content">
  					<h4>How to delete the workspace?</h4>
  					<p>Only the owner has the authority to delete the workspace because the owner is the creator. We do not allow Admins or Members to delete the workspace because once deleted the step can't be reverted. In that case the owner can loose all the work done.</p>
  				</div>
  			</div>
        <div class="col-sm-5 right-question">
          <div class="inner-content">
            <h4>How can I buy a membership?</h4>
            <p>We have total 3 memberships and out of them one is custom. A user can buy any of the membership based on requirements. For buying a membership we have a pricing page and clicking on Buy now/Contact sales will redirect the user to the next flow. Pay the amount if it not custom & if custom then fill the form & you are done.</p>
          </div>
        </div>
  		</div>
  	</div>
  </section>

  <section class="faq-section">
    <div class="container">
      <div class="row">
        <div class="col-sm-5">
          <div class="inner-content">
            <h4>How to create a board/category?</h4>
            <p>For creating a board/category the user should click on the plus button provided on left side menu next to Board text. When the page opens the user have to enter a board/category name and then click create board button and the board/category will be created and listed in left side menu under Boards.</p>

          </div>
        </div>
        <div class="col-sm-5 right-question">
          <div class="inner-content">
            <h4>How to edit the board/category name?</h4>
            <p>For editing the board/category name the user needs to take cursor to the board name on left side menu and 3 dots will appear on the right side of that board name. Click on the 3 dots and 2 options(Edit, Delete Permanently) will be there. Click on edit and edit the board/name in the field appears and click save board and all done.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="faq-section">
    <div class="container">
      <div class="row">
        <div class="col-sm-5">
          <div class="inner-content">
            <h4>How to delete the board/category?</h4>
            <p>For deleting the board/category the user needs to take cursor to the board name on left side menu and 3 dots will appear on the right side of that board name. Click on the 3 dots and 2 options(Edit, Delete Permanently) will be there. Click on delete permanently and all done.</p>
          </div>
        </div>
        <div class="col-sm-5 right-question">
          <div class="inner-content">
            <h4>How to change the workspace name?</h4>
            <p>Only Owner and Admin has the authority to change workspace name. For changing the workspace name the user should go to the settings page and in the field where workspace name appears edit the name and click check mark button next to field and the name will be edited.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="faq-section">
    <div class="container">
      <div class="row">
        <div class="col-sm-5">
          <div class="inner-content">
            <h4>Who can get Enterprise plan?</h4>
            <p>Anyone can have our enterprise plan. To become an enterprise plan member a user should contact our sales team by filling a simple form on pricing or subscription page. Our sales team will contact back asking about the requirements like number of invites needed and space. Enterprise plan is our custom plan in which a user can have number of invites and storage space as per their needs.</p>
          </div>
        </div>
        <div class="col-sm-5 right-question">
          <div class="inner-content">
            <h4>Is login mandatory to use workspace?</h4>
            <p>Yes, login is mandatory to use Crafttor's workspace. Without login we can not allow users to create and access their workspace. We have all the controls over workspaces and accounts based on the login of the users. We keep users details safe and secret in our database. So that our users need not to worry about their personal information shared with us.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="faq-section">
    <div class="container">
      <div class="row">
        <div class="col-sm-5">
          <div class="inner-content">
            <h4>How will Crafttor make my team more organised?</h4>
            <p>Your team can work anytime and any number of hours. They is no restriction of hours per day per team member. A team member can create boards, upload & organise assets.</p>
          </div>
        </div>
        <div class="col-sm-5 right-question">
          <div class="inner-content">
            <h4>Where can I upload assets from?</h4>
            <p>Currently we allow our users to upload assets from their system. We do not created any external app link yet to import or upload assets from.
            <br>We are working on to get Dropbox and Google Drive sync to import and upload assets from.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="faq-section">
    <div class="container">
      <div class="row">
        <div class="col-sm-5">
          <div class="inner-content">
            <h4>What does Crafttor Workspace do?</h4>
            <p>Crafttor Workspace is a cloud storage which allows creators to store their files/assets and makes it very easy to organise, share, collaborate their creatives with individuals or teams anytime or anywhere they want.</p>
          </div>
        </div>
        <div class="col-sm-5 right-question">
          <div class="inner-content">
            <h4>What about the quality when I move assets within Crafttor?</h4>
            <p>Your assets will always be in original state. We do not compress the asset while moving within Crafttor. We only move the original assets within boards.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

    <section class="faq-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-5">
            <div class="inner-content">
              <h4>What file formats Crafttor Workspace support?</h4>
              <p>From SVG to PNG, GIF to BMP. Crafttor Workspace is a great platform that supports number of formats. It also includes video formats MP4 to WEBM, FLV to WMV and more. There are some rare formats which Crafttor Workspace do not support.</p>
            </div>
          </div>
          <div class="col-sm-5 right-question">
            <div class="inner-content">
              <h4>What are the benefits of subscribing to Workspace?</h4>
              <p>Subscribing to Workspace unlocks a range of benefits, including access to more storage space, more number of workspaces and admin seats, early access to new features, premium content, and priority support.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="faq-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-5">
            <div class="inner-content">
              <h4>How much does a subscription to Crafttor Workspace cost?</h4>
              <p>The cost of a subscription to Crafttor Workspace varies depending on the plan you choose. We offer different subscription tiers to accommodate various preferences and budgets.</p>
            </div>
          </div>
          <div class="col-sm-5 right-question">
            <div class="inner-content">
              <h4>Do I need to create an account to subscribe?</h4>
              <p>Yes, to subscribe to our service, you will need to create an account. This allows us to provide you with a personalized experience and manage your subscription.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="faq-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-5">
            <div class="inner-content">
              <h4>Is my payment information secure?</h4>
              <p>Yes, we take your payment security seriously. We use secure payment processing methods to protect your personal and financial information.</p>
            </div>
          </div>
          <div class="col-sm-5 right-question">
            <div class="inner-content">
              <h4>Can I share my subscription with others?</h4>
              <p>Subscriptions to Crafttor Workspace are intended for individual use and cannot be shared with others. Sharing accounts may result in the suspension of your subscription. A user can add admin and member seats within subscription plan to share their work(assets, files, etc).</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="faq-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-5">
            <div class="inner-content">
              <h4>Can I upgrade my subscription plan?</h4>
              <p>Yes, you can upgrade your subscription plan at any time. Visit upgrade section to make the change and access new features within the new plan.</p>
            </div>
          </div>
          <div class="col-sm-5 right-question">
            <div class="inner-content">
              <h4>How can I get in touch with your support team?</h4>
              <p>You can contact our support team by filling above form with all the required fields. Alternatively, you can send an email to <b>info@crafttor.com</b>.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

        <section class="faq-section">
          <div class="container">
            <div class="row">
              <div class="col-sm-5">
                <div class="inner-content">
                  <h4>What information should I include when reaching out to support team?</h4>
                  <p>To assist you more effectively, please provide your full name, email Id and a brief description of your issue, and that would be great.</p>
                </div>
              </div>
              <div class="col-sm-5 right-question">
                <div class="inner-content">
                  <h4>What can I contact support team for?</h4>
                  <p>Our support team is here to assist you with product inquiries, product walk through, technical issues, account-related questions, and general support. Please don't hesitate to reach out for any concerns you may have.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

          <section class="faq-section">
            <div class="container">
              <div class="row">
                <div class="col-sm-5">
                  <div class="inner-content">
                    <h4>Do you have a physical office where I can visit in person?</h4>
                    <p>Currently, we do not have physical offices open to the public. We operate primarily online and provide support through digital channels.</p>
                  </div>
                </div>
                <div class="col-sm-5 right-question">
                  <div class="inner-content">
                    <h4>How can I provide feedback or suggestions about your products or services?</h4>
                    <p>We welcome your feedback and suggestions! You can share your thoughts through the "Contact Us" page or by emailing us at <b>info@crafttor.com</b>. Your input helps us improve and better serve you.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- <section class="faq-section">
            <div class="container">
              <div class="row">
                <div class="col-sm-12">
                  <div class="inner-content">
                    <h4 style="font-family: cursive; text-align: center; font-weight: 500;">We hope you could continue to enjoy your experience of using Crafttor Workspace as we are actively improving and building new features!</h4>
                  </div>
                </div>
              </div>
            </div>
          </section> -->

          <!-- Footer -->
          <footer class="site-footer">
            <div class="container">
            <div class="row">
              <div class="col-sm-3">
                <div class="coulmn-1">
                  <img src="assets/img/logo.svg">
                  <p>Digital assets management</p>
                  <a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
                </div>
              </div>
              <!-- 3 -->
              <div class="col-sm-2">
                <h5>Products</h5>
                <ul class="menu">
                  <li><a routerLink="/home">Workspace</a></li>
                  <li><a (click)="openMarketplace()">Marketplace</a></li>
                  <li><a routerLink="/features">Features</a></li>
                  <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
<li><a routerLink="/smart-storage">Smart storage</a></li>
                  <li><a routerLink="/effective-search">Effective search</a></li>
                  
                </ul>
              </div>

              <div class="col-sm-2">
                <h5>Plugins</h5>
                <ul class="menu">
                  <li><a href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
                  <li><a href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
                  <li><a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
                  <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
                  <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
                  <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
                  <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
<li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
                </ul>
              </div>

              <div class="col-sm-2">
                <h5>Solutions</h5>
                <ul class="menu">
                  <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
                  <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
                  <li><a routerLink="/box-alternative">Box alternative</a></li>
                  <li><a routerLink="/content-library">Content library</a></li>
                  <li><a routerLink="/user-profiling">User Profiling</a></li>
<li><a routerLink="/approvals">Creative approvals</a></li>
                </ul>
              </div>

              <div class="col-sm-2">
                <h5>Features</h5>
                <ul class="menu">
                  <li><a routerLink="/features/tagging">Tagging</a></li>
                  <li><a routerLink="/features/sharing">Sharing</a></li>
                  <li><a routerLink="/features/versioning">Versioning</a></li>
                  <li><a routerLink="/features/collaboration">Collaboration</a></li>
                  <li><a routerLink="/features/integration">Integration</a></li>
                </ul>
              </div>

              <div class="col-sm-2">
                <h5>Company</h5>
                <ul class="menu">
                  <li><a routerLink="/about-workspace">About Workspace</a></li>
                  <li><a routerLink="/contact">Contact Us</a></li>
                  <li><a routerLink="/terms">Terms & Conditions</a></li>
                  <li><a routerLink="/faq">FAQ</a></li>
                  <li><a routerLink="/feedbacks">Feedback</a></li>
                  <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
                  <li><a routerLink="/our-mission">Our mission</a></li>
                  <li><a routerLink="/partner-with-us">Partner with us</a></li>
                </ul>
              </div>

              <div class="col-sm-3 all-social-icons">
                <h5>Socials</h5>
                  <ul class="social-icons">
                    <li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
                      alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                    <li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                    <li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
                    <li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
                  </ul>
              </div>

              <div class="col-sm-12 text-center">
                  <small>&copy; 2025 Crafttor. All rights reserved</small>
                </div>
            </div>
            </div>
          </footer>
